import { React, useEffect } from "react";
import { Popover } from "@headlessui/react";
import posthog from "posthog-js";

import cashmereCover from "../../assets/cashmerecover.png";
import landingLogo from "../../assets/landing-logo.png";
import balloon from "../../assets/balloon.png";
import farmer from "../../assets/farmer.png";
import telescope from "../../assets/telescope.png";
import bonfida from "../../assets/bonfida.png";
import discord from "../../assets/discord.png";
import goki from "../../assets/goki.png";
import yc from "../../assets/yc.png";
import zebec from "../../assets/zebec.png";
import Typewriter from "typewriter-effect";
import WaitlistForm from "./WaitlistForm";

const navigation = {
  main: [
    { name: 'About Us', link: '#' },
    { name: 'Partners', link: '#' },
    // { name: 'Documentation', href: '#' },
    { name: 'Demo', link: 'https://calendly.com/shashankbuilds' },
  ],
  social: [
    {
      name: 'Twitter',
      link: 'https://twitter.com/cashmerewallet',
      icon: (props) => (
        <svg fill="currentColor" viewBox="0 0 24 24" {...props}>
          <path d="M8.29 20.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0022 5.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.072 4.072 0 012.8 9.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 012 18.407a11.616 11.616 0 006.29 1.84" />
        </svg>
      ),
    },
    {
      name: 'Discord',
      link: 'https://discord.gg/EGpbsCPZwK',
      icon: (props) => (
        <img
          className="h-6 w-6"
          src={discord}
          alt=""
        />
      ),
    },
    // {
    //   name: 'Telegram',
    //   href: '#',
    //   icon: (props) => (
    //     <svg fill="currentColor" viewBox="0 0 24 24" {...props}>
    //       <path
    //         fillRule="evenodd"
    //         d="M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.45 2.525c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zm-.081 1.802h-.468c-2.456 0-2.784.011-3.807.058-.975.045-1.504.207-1.857.344-.467.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.047 1.023-.058 1.351-.058 3.807v.468c0 2.456.011 2.784.058 3.807.045.975.207 1.504.344 1.857.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058h.08c2.597 0 2.917-.01 3.96-.058.976-.045 1.505-.207 1.858-.344.466-.182.8-.398 1.15-.748.35-.35.566-.683.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-4.041v-.08c0-2.597-.01-2.917-.058-3.96-.045-.976-.207-1.505-.344-1.858a3.097 3.097 0 00-.748-1.15 3.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.023-.047-1.351-.058-3.807-.058zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 1.802a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z"
    //         clipRule="evenodd"
    //       />
    //     </svg>
    //   ),
    // },
  ],
}


export default function Landing() {

  useEffect(() => {
    if (!window.location.href.includes('localhost')) {
      posthog.init(
        "phc_n6xC1XPBfHmDn63jnywl4dCaLxCPmHb6Pp0HC2bHhDf",
        { api_host: 'https://app.posthog.com' },
      );
    }
  });

  return (
    <div className="bg-white">
      <div className="relative overflow-hidden">
        <Popover as="header" className="relative">
          <div className="bg-white pt-6 sm:px-4 lg:px-24">
            <nav
              className="relative mx-auto flex items-center justify-between"
              aria-label="Global">
              <div className="flex items-center pl-4">
                <div className="flex items-center justify-between w-full md:w-auto">
                  <img
                    className="h-10 lg:h-14 w-auto"
                    src={cashmereCover}
                    alt=""
                  />
                </div>
              </div>
              {/* about us, demo, contact us */}
              <div className="py-2 md:flex md:items-center md:space-x-6 sm:mr-4">
                <a
                  id="launch-app"
                  href="https://app.cashmere.finance/"
                  className="inline-flex items-center px-4 py-2 font-semibold rounded-full text-white bg-indigo-500 hover:bg-indigo-600 hover:text-white focus:outline-none focus:ring-1 focus:ring-indigo-600 focus:ring-offset-white">
                  Launch App
                </a>
              </div>
            </nav>
          </div>
        </Popover>
        <main>
          <div className="pt-10 bg-white sm:pt-16 lg:pt-8 lg:pb-14 lg:overflow-hidden">
            <div className="lg:grid lg:grid-cols-7">

              {/* Header section */}
              <div className="lg:col-span-3 gap-0 sm:px-12 md:px-16 lg:pl-40 lg:pr-16 lg:pb-24 lg:block lg:w-full">
                <div className="sm:py-20 lg:py-60">
                  <h1 className="flex-col mt-4 sm:text-3xl md:text-5xl lg:text-6xl tracking-tight font-extrabold text-gray-700 mt-5">
                    <span className="flex justify-center items-center text-center lg:justify-start lg:text-left">
                      The Solana <br></br>multisig wallet
                    </span>
                    <div className="flex justify-center space-x-3 pb-3 bg-clip-text text-indigo-500 lg:justify-start">
                      for&nbsp;
                      <Typewriter
                        options={{
                          strings: [
                            "startups.",
                            "DAOs.",
                            "NFT artists.",
                            "partners.",
                            "frens.",
                          ],
                          autoStart: true,
                          loop: true,
                        }}
                      />
                    </div>
                  </h1>
                </div>
              </div>
              {/* Image 1 Slot */}
              <div className="lg:col-span-4 mt-12 lg:m-0 lg:relative">
                <div className="h-full flex items-center content-center justify-left">
                  <img
                    className="sm:w-full lg:w-5/6 pb-20 px-12"
                    src={landingLogo}
                    alt=""
                  />
                </div>
              </div>
            </div>

            {/* partnerships */}
            <div className="px-12 lg:px-60 pt-6 pb-12 items-center bg-indigo-50">
              <div className="flex justify-center text-stone-600 text-2xl py-6 font-semibold">
                  Our Partners
              </div>
              {/* <div className="px-12 grid grid-rows-4 md:grid-cols-4 md:grid-rows-1 md:inline-flex"> */}
              <div className="px-12 md:grid sm:grid-cols-2 md:grid-cols-4 md:inline-flex">
                <div className="flex justify-center items-center">
                  <img
                    className="w-5/6 sm:w-3/6"
                    src={yc}
                    alt="ycombinator"
                  />
                </div>
                <div className="flex justify-center items-center">
                  <img
                    className="w-5/6 sm:w-3/6"
                    src={bonfida}
                    alt="bonfida"
                  />
                </div>
                <div className="flex justify-center items-center">
                  <img
                    className="w-5/6 sm:w-3/6"
                    src={goki}
                    alt="goki"
                  />
                </div>
                <div className="flex justify-center items-center">
                  <img
                    className="w-5/6 sm:w-3/6"
                    src={zebec}
                    alt="zebec"
                  />
                </div>
              </div>
            </div>

            {/* Start tag lines */}
            <div className="py-20 md:py-40">

              {/* First section */}
              <div className="py-12 sm:px-6 lg:px-72 lg:grid lg:grid-cols-2 lg:gap-6 inline-flex content-center">
                {/* Image 1 Slot */}
                <div className="mt-12 mb-4 lg:m-0 lg:relative">
                  <div className="px-4 lg:max-w-none lg:px-0">
                    <img
                      className="w-5/6"
                      src={farmer}
                      alt=""
                    />
                  </div>
                </div>
                {/* First text section */}
                <div className="flex items-center px-12 w-full">
                  <h1 className="mt-4 tracking-tight font-semibold text-gray-700 mt-6 sm:text-xl lg:text-3xl">
                    <span className="flex lg:text-left">
                      Manage and transfer your funds with ease and peace of mind
                    </span>
                  </h1>
                </div>
              </div>

              {/* Second section */}
              <div className="py-12 sm:px-6 lg:px-60 g:grid lg:grid-cols-2 lg:gap-6 inline-flex">
                {/* Second text section */}
                <div className="flex items-center px-12 w-full">
                  <h1 className="w-full mt-4 tracking-tight font-semibold text-gray-700 mt-6 sm:text-xl lg:text-3xl">
                    <span className="w-full lg:text-left">
                      <div className="w-full py-4">Remote work has never been easier...</div>
                      <div className="w-full">Approve your startup's transactions from anywhere</div>
                    </span>
                  </h1>
                </div>
                {/* Image 2 Slot */}
                <div className="mt-12 mb-4 lg:m-0 lg:relative">
                  <div className="px-4 lg:max-w-none lg:px-0">
                    <img
                      className="w-5/6"
                      src={balloon}
                      alt=""
                    />
                  </div>
                </div>
              </div>

              {/* Third section */}
              <div className="py-12 sm:px-6 lg:px-60 lg:grid lg:grid-cols-2 lg:gap-6 inline-flex">
                {/* Image 3 Slot */}
                <div className="mt-12 mb-4 lg:m-0 lg:relative">
                  <div className="px-4 lg:max-w-none lg:px-0">
                    <img
                      className="w-5/6"
                      src={telescope}
                      alt=""
                    />
                  </div>
                </div>
                {/* Third text section */}
                <div className="flex items-center px-12 w-full">
                  <h1 className="mt-4 tracking-tight font-semibold text-gray-700 mt-6 sm:text-xl lg:text-3xl">
                    <span className="flex lg:text-left">
                    No more rug pulls or single points of failure
                    </span>
                  </h1>
                </div>
              </div>
            </div>
            {/* End taglines */}

            {/* Mailing List */}
            <div className="py-12 bg-indigo-50 sm:px-6 lg:px-60 lg:grid lg:grid-cols-2 lg:gap-12 inline-flex justify-center items-center ">
              <div className="flex items-center px-4 w-full">
                <h1 className="tracking-tight font-bold text-gray-800 sm:text-xl lg:text-3xl">
                  <span className="flex lg:text-left">
                  Join our mailing list for all product updates!
                  </span>
                </h1>
              </div>
              <div className="justify-center items-center mt-10 mr-4">
                <WaitlistForm />
              </div>
            </div>
          </div>

          {/* Footer */}
          <footer className="bg-white">
            <div className="mx-auto pt-6 pb-12 px-4">
              <nav className="-mx-5 -my-2 flex flex-wrap justify-center" aria-label="Footer">
                {navigation.main.map((item) => (
                  <div key={item.name} className="px-5 py-2">
                    <a href={item.link} className="text-base text-gray-500 hover:text-gray-900">
                      {item.name}
                    </a>
                  </div>
                ))}
              </nav>
              <div className="mt-8 flex justify-center space-x-6">
                {navigation.social.map((item) => (
                  <a key={item.name} href={item.link} className="text-gray-400 hover:text-gray-500">
                    <span className="sr-only">{item.name}</span>
                    <item.icon className="h-6 w-6" aria-hidden="true" />
                  </a>
                ))}
              </div>
              <p className="mt-8 text-center text-base text-gray-400">&copy; 2022 Cashmere Finance, Inc. All rights reserved.</p>
            </div>
          </footer>
        </main>
      </div>
    </div>
  );
}
